<div class='verification-box'>
    <img class="closebutton pointer m-t-5" alt="Close" (click)="closeDialog()">


    <div class="header">
        <h3>Verify Email </h3>
    </div>
    <!-- <hr> -->
    <div class="otp-form">
        <form (ngSubmit)="onOTPFormSubmit()" [formGroup]="form" class=" text-center">
            <p class="f-12">Enter the code sent to the <b>{{data.email}}</b> </p>
            <div class="row d-flex justify-content-between " id="otpInput">
                <input type="number" formControlName="input1" class="form-control form-group" maxlength="1"
                    [class.invalidOTp]="verifyOTPError">
                <input type="number" formControlName="input2" class="form-control form-group" maxlength="1"
                    [class.invalidOTp]="verifyOTPError">
                <input type="number" formControlName="input3" class="form-control form-group" maxlength="1"
                    [class.invalidOTp]="verifyOTPError">
                <input type="number" formControlName="input4" class="form-control form-group" maxlength="1"
                    [class.invalidOTp]="verifyOTPError">
                <input type="number" formControlName="input5" class="form-control form-group" maxlength="1"
                    [class.invalidOTp]="verifyOTPError">
                <input type="number" formControlName="input6" class="form-control form-group" maxlength="1"
                    [class.invalidOTp]="verifyOTPError">
            </div>
            <mat-error class="m-b-10">{{verifyOTPErrorMsg}}</mat-error>
            <p class=" otp-sent">{{otpMsg}}</p>
            <div class="resend">
                <p>Didn't get otp?
                    <a (click)="resendOtp()" [class.disabled]="sendOTPStart">Resend OTP </a>
                    <span *ngIf="sendOTPStart">(in {{this.timerMinute.toLocaleString('en-US', {
                        minimumIntegerDigits: 2
                        })}}:{{this.timerSecond.toLocaleString('en-US', { minimumIntegerDigits: 2 })}})</span>
                </p>
                <p><b>Note:</b> Check your spam or promotions email folder.</p>
            </div>
            <button type="submit" class="send-button m-t-5 m-b-20" [disabled]="form.invalid">Verify Email
                Address</button>

        </form>
    </div>

</div>
